import Libraries from './components/index.vue';
export { default as ShareLibraryOnboarding } from './components/tabs/ShareLibraryOnboarding.vue';
export { default as ThirdPartyPlacementPopup } from './components/tabs/templates/ThirdPartyPlacementPopup.vue';
import { MODULE_NAME } from './constants';
import { registerStore } from '@modules/common';
import store from './store';
import { mutations } from './store/types';

registerStore(MODULE_NAME, { store });
export default Libraries;
export { MODULE_NAME, mutations };
